import axios from 'axios';

import CacheInterceptor from './cache-interceptor.js';
import AuthInterceptor from './auth-interceptor';

function useInterceptors (handler: any): void {
  axios.interceptors.request.use(handler.requestHandler);
  axios.interceptors.response.use(
    handler.responseHandler,
    handler.errorHandler
  );
}

const AxiosConfig = {
  install (): void {
    axios.defaults.withCredentials = true;

    useInterceptors(CacheInterceptor); // must be first
    useInterceptors(AuthInterceptor);
  }
};

export default AxiosConfig;
